import * as React from "react";
import { Container } from "@mantine/core";
import { Hero } from "./Hero";

export function HomePage() {
  return (
    <div>
      <Container>
        <Hero />
      </Container>
    </div>
  );
}
